import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import twitterFill from '@iconify/icons-eva/twitter-fill'
import linkedinFill from '@iconify/icons-eva/linkedin-fill'
import facebookFill from '@iconify/icons-eva/facebook-fill'
import instagramFilled from '@iconify/icons-ant-design/instagram-filled'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import { sentenceCase } from 'change-case'
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'

import {
  Box,
  Card,
  Grid,
  Avatar,
  Tooltip,
  Divider,
  Stack,
  Typography,
  IconButton,
  AvatarGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core'
// utils
import { fShortenNumber } from 'src/utils/formatNumber'
//
import SvgIconStyle from 'src/components/SvgIconStyle'
import Label from 'src/components/Label'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Message, MessageSharp, RequestQuote } from '@material-ui/icons'
import moment from 'moment'
import { getAgoString } from 'src/common/Helper'
import { useSnackbar } from 'notistack'
import { Link } from 'react-router-dom'
import { empty } from 'src/Helpers/Common'
import { COMPANY_LOGO, REST_API_END_POINT, FacilityTypes } from 'src/constants/Defaultvalues'
import QuickbookLogo from '../../../assets/quickbookLogo-removebg-preview.png'
import AVALARALOGO from '../../../assets/Avalara_Logo.png'
import { useState } from 'react'
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import copyFill from '@iconify/icons-eva/copy-fill';
import FullScreenDialogEstimate from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogEstimate'
import FullScreenDialogSalesOrder from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogSalesOrder'
import { UserMoreMenu } from '../user/list'
import ConfirmationPopup from 'src/components/confirmationPopup'
import axios from 'axios'

// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  //    background: `url(${src}) center/cover no-repeat`
})

// ----------------------------------------------------------------------

function InfoItem(number) {
  return (
    <Grid item xs={4}>
      <Typography
        variant="caption"
        sx={{ mb: 0.5, color: 'text.secondary', display: 'block' }}
      >
        Follower
      </Typography>
      <Typography variant="subtitle1">{fShortenNumber(number)}</Typography>
    </Grid>
  )
}

OfficialCard.propTypes = {
  card: PropTypes.object.isRequired,
  team_member: PropTypes.array.isRequired,
}
const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 25,
  height: 28,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '5px',
  color: theme.palette.success.main,
  // backgroundColor: alpha(theme.palette.success.main, 0.16),
}));

export default function OfficialCard({
  card,
  team_member,
  communityId,
  clientId,
  communityName,
  CommunityProjects,
  quotationView,
  proposalView,
  designOrder,
  setRenderCards,
  renderCards,
  handleOpenViewSalesOrder,
  handleOpenDetailsSalesOrder,
  setOpenSalesOrder,
  opeSalesOrder,
  handleOpenViewEstimate,
  handleOpenDetails,
  SalesOrderId,
  setSalesOrderId,
  salesOrderName,
  setSalesOrderName,
  removePopupData,
  openPurchaseOrder,
  setOpenPurchaseOrder,
  PurchaseOrderName,
  purchaseOrderId,
  isEditPurchaseOrder,
  setIsEditPurchaseOrder,
  setPurchaseOrderId,
  setPurchaseOrderName,
  CommunityJob,
  communityDesignOrder,
  handleOpenDetailsPurchaseOrder,
  handleOpenViewPurchaseOrder,
  estimateNewCard,
  salesOrderNewCard,
  designOrderNewCard,
  currentTab,
  isSalesOrder,
  handleOpenViewDesignOrder,
  handleOpenDetailsDesignOrder
  // handleOpenEstimate,setHandleOpenEstimate,estimateId,setEstimateId,estimateName,setEstimateName,isEditEstimate,setIsEditEstimate
}) {
  console.log('currentTabeeeeeeeeeeeeeeeee', currentTab)
  const theme = useTheme()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  let user = JSON.parse(localStorage.getItem('user'))
  let isClient =user?.isClient
  
  let userType =isClient ? 3 : user.user_type
  let userId = user.user_id

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  
  const explodedPermissions = user?.exploded_permissions
  const handleOpenEstimateTemp = localStorage.getItem(
    'estimateOpenProductionPopup',
  )
  const [handleOpenEstimate, setHandleOpenEstimate] = useState(
    handleOpenEstimateTemp || false,
  )
  const [estimateId, setEstimateId] = useState(false)
  const [estimateName, setEstimateName] = useState(false)
  const [isEditEstimate, setIsEditEstimate] = useState(false)

  const [isEditSalesOrder, setIsEditSalesOrder] = useState('')
  const {
    image,
    message,
    timestamp,
    id,
    added_by_profile_pic,
    name,
    status,
    is_from_client,
    hold,
    design_order_job_status,
    request,
    people,
    description,
    subject,
    submission_deadline,
    msg_count,
    proposal_count,
    participation_ends,
    installation_start_date,
    installation_end_date,
    services,
    accept_status,
    thumbnail,
    due_date,
    cover_image,
    invoice_total,
    invoice_grand_total,
    partners,
    customer_pic,
    community_name,
    installationStatus,
    allInstallationCompleted,
    installation_acceptance,
   customer_name,
   awarded,
   paymentMode,
   quotation_status,
   quotation,
   statusRfp,
   syncWithQuickbooks,
   doc_number,
   est_doc_number,
  min_payment_status,
  project_category,
  job_category_name,
  installationCompleteStatus,
  billing_type,
  noServiceNoTask,
  proj_status,
  attachment_count,
  is_in_queue,
  send_client_app_req,
  attachment,
  isFromDesignOrder,
  duplicated_from,
  edited_by,
  isNewDesigns,
  isProject,
  isReview,
  avalara_code,
  partial_install,
  is_split_order,
  for_parent_facility,
  origin_facility_id
} = card

console.log('proj_status proj_status',proj_status)

  const filteredAttachments = designOrder 
    ? attachment?.filter(imageItem=>(imageItem?.isDesign == 1 && (imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img"))) || [] 
    : attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
console.log('cardcardcardcard card',card)
 
  let customer_image = partners?.filter(
    (item) => item?.profile_pic != 'avatar.jpg',
  )
  let accepted_customer_image = partners
    ?.filter((item) => {
      item?.profile_pic != 'avatar.jpg' && item?.status == 1
    })
    ?.map((data) => {
      return data?.profile_pic
    })
  // console.log('customer_image--',customer_image);
  // console.log('accepted_customer_image--',accepted_customer_image);
  //  const currentUnix = moment().unix()
  //  console.log(currentUnix,'))))))))))))))))')
  //   console.log(submission_deadline,'$$$$$$$$$$$$$$$$')
  const updatedAt = moment.unix(timestamp).format('YYYY-MM-DD')
  //status color
  let CompletedStatus =
    installationCompleteStatus == 1
      ? 'Installs'
      : installationCompleteStatus == 2
      ? 'Pick up'
      : CommunityJob 
      ? 'Installs' 
      : installationCompleteStatus == 3 
      ? 'Shipping'
      : ''
  const getStatusColorAndLabel = (
    status,
    installationStatus,
    allInstallationCompleted,
    accepted,
    min_payment_status,
    billing_type,
    noServiceNoTask,
    proj_status,
    job_category_name,
    partial_install,
  ) => {
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color:hold == 1 ? 'warning' : 'info', label: hold == 1 ? 'Hold' : 'Open'}
      case 3:
        return {
          color: `${
            hold === 1 ? 'warning':
            project_category == 13
              ? 'primary'
              : min_payment_status == 0
              ? 'warning'
              : 'primary'
          }`,
          label: `${
            hold === 1 ? 'Hold' :
            project_category == 13 || billing_type == 0
              ? 'Approved'
              : min_payment_status == 1
              ? 'Approved and Paid'
              : 'Approved and Payment Due'
          }`,
        }
      // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
      case 4:
        // return { color: 'success', label: !empty(allInstallationCompleted) ? 'Completed' : (!empty(installationStatus) ? 'Installation' : 'In Production') }
        return {
          color: hold==1 ? 'warning' : (noServiceNoTask == 1 && proj_status == 3) ? 'success' :
            empty(accepted) && !empty(allInstallationCompleted)
              ? 'warning'
              : 'success',
          label: hold==1 ? 'Hold' : (noServiceNoTask == 1 && proj_status == 3 && project_category !== 12) ? 'No Service No Task' :
          isReview ==2 && (!empty(allInstallationCompleted)) ? "Awaiting Review" :
            empty(accepted) && (!empty(allInstallationCompleted))
              ? `${CompletedStatus} Completed & Awaiting approval`
              : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed'
              : !empty(accepted) && (!empty(allInstallationCompleted))
              ? `${CompletedStatus} Completed & Approved`
              : !empty(installationStatus)
              ? partial_install == 1 ? 'Partially Installed':proj_status !=3 ? `In-Production` : `${CompletedStatus}`
              : CommunityJob ? `${CompletedStatus} Completed & Approved` : `In-Production`,
        } // return { color: 'primary', label: 'Converted to Job' };
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
         case 10:
        return { color: 'success', label: 'Completed -No Service No Task' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelQuickbid = (status, quotation) => {
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color: 'info', label: 'Open' }
      case 3:
        return { color: 'primary', label: 'Evaluating' }
      case 4:
        return {
          color: quotation == 0 ? 'default' : 'success',
          label: quotation == 0 ? 'Archive' : 'Approved',
        }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelDesignOrder = (status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue) => {
    // HOLD: hold=1 AND status !=0
    if (hold == 1 && status != 0) {
      return {
        color: 'warning',
        label: 'Hold',
      }
    }
    
    // REJECTED: status=6 AND hold=0
    if (status == 6 && hold == 0) {
      return {
        color: 'error',
        label: 'Rejected',
      }
    }
    
    // APPROVED: status=2 AND hold=0
    if (status == 2 && hold == 0) {
      return {
        color: 'success',
        label: 'Approved',
      }
    }
    
    // DESIGN JOB COMPLETED: design_order_job_status = 3 AND send_client_app_req=0 AND status !=0 AND hold = 0
    // This should be checked before status 1 conditions
    if (design_order_job_status == 3 && send_client_app_req == 0 && status != 0 && hold == 0) {
      return {
        color: 'success',
        label: 'Design Job Completed',
      }
    }
    
    // Check if there are design attachments (doa.id IS NOT NULL equivalent)
    // Use attachment_count as primary check, then check attachment array
    const hasDesignAttachments = attachment_count > 0 || (attachment && attachment.length > 0 && attachment.some(att => att?.isDesign == 1));
    
    // For status 1, check conditions in priority order
    if (status == 1 && hold == 0) {
      // AWAITING APPROVAL: status=1 AND hold=0 AND send_client_app_req=1 AND doa.id IS NOT NULL
      if (send_client_app_req == 1 && hasDesignAttachments) {
        return {
          color: 'warning',
          label: 'Awaiting Approval',
        }
      }
      
      // IN DESIGN: doa.id IS NOT NULL AND status = 1 AND hold = 0 AND send_client_app_req=0 AND design_order_job_status != 3
      // if (send_client_app_req == 0 && design_order_job_status != 3 && hasDesignAttachments) {
      if (send_client_app_req == 0 && design_order_job_status == 2) {
        return {
          color: 'info',
          label: 'In Design',
        }
      }
      
      // NEW: status=1 AND hold=0 AND doa.id IS NULL AND design_order_job_status != 3 AND send_client_app_req=0
      // if (!hasDesignAttachments && design_order_job_status != 3 && send_client_app_req == 0) {
      if (send_client_app_req == 0 && design_order_job_status == 1 && is_in_queue == 1) {
        return {
          color: 'info',
          label: 'In Queue',
        }
      }
      if (send_client_app_req == 0 && design_order_job_status == 1 && is_in_queue == 0) {
        return {
          color: 'info',
          label: 'New',
        }
      }
      
      // Default fallback for status 1
      return {
        color: 'info',
        label: 'Open',
      }
    }
    
    // Other status cases
    switch (status) {
      case 3:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Hold' : 'Approved',
        }
      case 4:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Draft',
        }
      case 5:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Closed',
        }
      default:
        return {
          color: hold == 1 ? 'warning' : 'default',
          label: hold == 1 ? 'Hold' : 'Open',
        }
    }
  }
  const getStatusColorAndLabelForProposal = (status) => {
    switch (status) {
      case 1:
        return { color: 'info', label: 'Open' }
      case 2:
        return { color: 'warning', label: 'Awarded' }
      case 3:
        return { color: 'error', label: 'Rejected' }
      case 4:
        return { color: 'success', label: 'Approved' }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 7:
        return { color: 'success', label: 'Paid' }
      default:
        return { color: 'info', label: 'Open' }
    }
  }

  const handleUpdateHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
        {
          projectId: Number(id),
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const handleUpdateSalesOrderHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: Number(id),
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Approved' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]
  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]

  // const handleOpenViewEstimate = (id,name) =>{
  //   setIsEditEstimate(true)
  //   setEstimateId(id)
  //   setEstimateName(name)
  //   setHandleOpenEstimate(true)
  //   console.log('hjsfgdhjdhbfhhhh')
  //   localStorage.setItem('estimateProjectId', id);
  //   localStorage.setItem('estimateProjectName', name);
  //   localStorage.setItem('isEditEstimate', "true");
  //   localStorage.setItem('estimateOpenProductionPopup', 'true');

  // }
  // const handleOpenDetails= (id,name) =>{
  //   setIsEditEstimate(false)
  //   setEstimateId(id)
  //   setEstimateName(name)
  //   setHandleOpenEstimate(true)
  //   localStorage.setItem('estimateProjectId', id);
  //   localStorage.setItem('estimateProjectName', name);
  //   localStorage.setItem('isEditEstimate', "false");
  //   localStorage.setItem('estimateOpenProductionPopup', 'true');
  // }
  // const handleOpenViewSalesOrder = (id,name) =>{
  //   setIsEditSalesOrder(true)
  //   setSalesOrderId(id)
  //   setSalesOrderName(name)
  //   setOpenSalesOrder(true)
  //   localStorage.setItem('salesOrderProjectId', id);
  //   localStorage.setItem('salesOrderProjectName', name);
  //   localStorage.setItem('isEditSalesOrder', "true");
  //   localStorage.setItem('salesOrderOpenPopup', 'true');

  // }
  // const handleOpenDetailsSalesOrder= (id,name) =>{
  //   setIsEditSalesOrder(false)
  //   setSalesOrderId(id)
  //   setSalesOrderName(name)
  //   setOpenSalesOrder(true)
  //   localStorage.setItem('salesOrderProjectId', id);
  //   localStorage.setItem('salesOrderProjectName', name);
  //   localStorage.setItem('isEditSalesOrder', "false");
  //   localStorage.setItem('salesOrderOpenPopup', 'true');
  // }
  // const handleOpenViewPurchaseOrder = (id, name) => {
  //   setIsEditPurchaseOrder(true)
  //   setPurchaseOrderId(id)
  //   setPurchaseOrderName(name)
  //   setOpenPurchaseOrder(true)
  //   localStorage.setItem('purchaseOrderProjectId', id)
  //   localStorage.setItem('purchaseOrderProjectName', name)
  //   localStorage.setItem('isEditPurchaseOrder', 'true')
  //   localStorage.setItem('purchaseOrderOpenPopup', 'true')
  // }
  // const handleOpenDetailsPurchaseOrder = (id, name) => {
  //   setIsEditPurchaseOrder(false)
  //   setPurchaseOrderId(id)
  //   setPurchaseOrderName(name)
  //   setOpenPurchaseOrder(true)
  //   localStorage.setItem('purchaseOrderProjectId', id)
  //   localStorage.setItem('purchaseOrderProjectName', name)
  //   localStorage.setItem('isEditPurchaseOrder', 'false')
  //   localStorage.setItem('purchaseOrderOpenPopup', 'true')
  // }

  return (
    <>
    <Card
    sx={{ 
      ml: 2, 
      opacity: quotationView && quotation_status === 4 && quotation === 0 ? '75%':'100%',
      border: is_split_order ? 
        `1px solid ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
          theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
          theme.palette.grey[500]}` : 'none',
      boxShadow: is_split_order ? 
        `0 -2px 8px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
          theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
          theme.palette.grey[500]}40, 0 4px 12px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
          theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
          theme.palette.grey[500]}30, 0 2px 6px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
          theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
          theme.palette.grey[500]}20` : 'none',
    }}
      // sx={{ ml: 2 , opacity: quotationView && quotation_status === 4 && quotation === 0 ? '75%':'100%'}}
      id={id}
      onClick={() => {
        //    navigate(PATH_DASHBOARD.blog.viewproject)
      }}
    >
      <CardMediaStyle>
        {/* <IconButton
        sx={{
          top: 8,zIndex:500,color:theme.palette.grey.A100,
          right: 5,
          position: 'absolute'
        }}
      >
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton> */}
          {/* <SvgIconStyle
          color="paper"
          src={image}
          sx={{
            width: 144,
            height: 62,
            zIndex: 10,
            bottom: -26,
            position: 'absolute'
          }}
        /> */}

          <AvatarGroup
            max={7}
            sx={{ '& .MuiAvatar-root': { width: 62, height: 62, zIndex: 10 } }}
          >
            {team_member?.length > 0 &&
              team_member?.map((person) => {
                return (
                  <Tooltip title={person?.member_name}>
                    <Avatar
                      key={person.id}
                      sx={{
                        width: 30,
                        height: 30,
                        position: 'absolute',
                        transform: 'translateY(-50%)',
                      }}
                      alt={person?.member_name}
                      src={person?.profile_pic}
                    />
                  </Tooltip>
                )
              })}
          </AvatarGroup>
          <CoverImgStyle
            alt="cover"
            src={
              filteredAttachments?.[0]?.name
                ? filteredAttachments[0].name
                : customer_pic && customer_pic !== 'avatar.jpg'
                ? customer_pic
                : COMPANY_LOGO
            }
            //thumbnail ? thumbnail :
            // ((accepted_customer_image?.length > 0) ? accepted_customer_image[0] : customer_image[0]?.profile_pic || '/static/mock-images/avatars/avatar_default1.jpg')} //thumbnail ? thumbnail :
            // communityName && (cover_image ? cover_image : '/static/mock-images/avatars/avatar_default1.jpg') ||
          />
          <Box
            sx={{
              position: 'absolute',
              top: 35,
              right: 10,
              zIndex: 20,
              borderRadius: '50%',
              backdropFilter: 'blur(6px)',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
            }}>
                  {(user?.user_type !=3 && currentTab!="APPROVED" && designOrder) && (status === 1 || status === 6) &&
                    <UserMoreMenu
                      hold={hold}
                      {...(currentTab!="APPROVED" && (status === 1 || status === 6) ? { onHold:()=>{
                        if(explodedPermissions?.some(permission => ['Hold Design Order Jobs'].includes(permission))){
                          setOpenHoldPopup(true);
                        }else{
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                        }
                      }} : {})}
          
                    />
                  }

                  {(user?.user_type !=3 && (proj_status !== 3 && isSalesOrder )) &&
                    <UserMoreMenu
                      hold={hold}
                      onHold={() => {
                        setOpenHoldPopup(true);
                      }}
                    />
                  }

            <Dialog
              open={openHoldPopup}
              onClose={() => {
                setOpenHoldPopup(false);
                setHoldReason('');
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{ invisible: true }}
            >
              <DialogTitle id="alert-dialog-title">
                {hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {
                    designOrder ? (
                      hold === 1
                        ? 'You want to move this Design Order from Hold.'
                        : 'You want to move this Design Order to Hold.'
                    ) : (
                      hold === 1
                        ? 'You want to move this Sales Order from Hold.'
                        : 'You want to move this Sales Order to Hold.'
                    )
                  }
                  {/* {hold === 1
                    ? 'You want to move this Design Order from Hold.'
                    : 'You want to move this Design Order to Hold.'} */}
                </DialogContentText>
                {(hold === 0)? (
                  <TextField
                    sx={{ width: 400 }}
                    label="Reason"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={7}
                    value={holdReason}
                    onChange={(e) => {
                      setHoldReason(e.target.value);
                      if (holdReasonError) setHoldReasonError('');
                    }}
                    error={Boolean(holdReasonError)}
                    helperText={holdReasonError}
                  />
                ) : ''}
              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  onClick={async () => {
                    if ((hold === 0 ) && !holdReason.trim()) {
                      setHoldReasonError(`Reason is required to put this ${designOrder ?'Design Order on Hold' : 'Sales Order on Hold' }.`);
                      return;
                    }

                    setIsSubmittingHold(true);
                    if(designOrder){
                      await handleUpdateHoldStatus(holdReason);
                    }else{
                      await handleUpdateSalesOrderHoldStatus(holdReason)
                    }
                    setIsSubmittingHold(false);
                    setOpenHoldPopup(false);
                    setHoldReason('');
                    setHoldReasonError('');
                  }}
                  disabled={isSubmittingHold}
                >
                  {isSubmittingHold ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    'OK'
                  )}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setOpenHoldPopup(false);
                    setHoldReason('');
                  }}
                  sx={{ color: theme.palette.error.main }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>

            </Box>
          <Stack sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{ position: 'absolute', top: 8, left: 10, zIndex: 10 }}
            >
              {CommunityProjects ? (
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={colors[status]}
                >
                  {option.find((opt) => opt.id === status).value}
                </Label>
              ) : (
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={
                    designOrder
                      ? getStatusColorAndLabelDesignOrder(status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue).color
                      : quotationView
                      ? getStatusColorAndLabelQuickbid(
                          quotation_status,
                          quotation,
                        ).color
                      : proposalView
                      ? getStatusColorAndLabelForProposal(
                          userType != 3 ? (paymentMode ? 7 : awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                        ).color
                      : getStatusColorAndLabel(
                          status,
                          installationStatus,
                          allInstallationCompleted,
                          installation_acceptance,
                          min_payment_status,
                          billing_type,
                          noServiceNoTask,
                          proj_status,
                          job_category_name,
                          partial_install,
                        ).color
                  }
                >
                  <Tooltip
                    title={
                      designOrder
                        ? getStatusColorAndLabelDesignOrder(status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue).label
                        : quotationView
                        ? getStatusColorAndLabelQuickbid(
                            quotation_status,
                            quotation,
                          ).label
                        : proposalView
                        ? getStatusColorAndLabelForProposal(
                            userType != 3 ? (paymentMode? 7:awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                          ).label
                        : getStatusColorAndLabel(
                            status,
                            installationStatus,
                            allInstallationCompleted,
                            installation_acceptance,
                            min_payment_status,
                            billing_type,
                            noServiceNoTask,
                            proj_status,
                            job_category_name,
                            partial_install,
                          ).label
                    }
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        minWidth:80,
                        maxWidth: 80, // Adjust as necessary
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {designOrder
                          ? getStatusColorAndLabelDesignOrder(status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue)
                              .label
                          : quotationView
                          ? getStatusColorAndLabelQuickbid(
                              quotation_status,
                              quotation,
                            ).label
                          : proposalView
                          ? getStatusColorAndLabelForProposal(
                              userType != 3 ? (paymentMode? 7:awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                            ).label
                          : getStatusColorAndLabel(
                              status,
                              installationStatus,
                              allInstallationCompleted,
                              installation_acceptance,
                              min_payment_status,
                              billing_type,
                              noServiceNoTask,
                              proj_status,
                              job_category_name,
                              partial_install,
                            ).label}
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              )}
            </Typography>
            {
              estimateNewCard || salesOrderNewCard || designOrderNewCard ?
              <Typography
              sx={{ position: 'absolute', top: 8, 
                right: 110, zIndex: 10 }}
            >
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  // color={'secondary'}
                >
                 <IconWrapperStyle>
                    <Icon width={20} height={20} icon={briefcaseFill} />
                  </IconWrapperStyle>
                  <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 80,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        New
                      </span>
                    </Typography>
                </Label>
              
            </Typography> : ''
            }

            {
              
             ( designOrder && isNewDesigns == 1) && (!send_client_app_req && userType !==3) ?(
    <Typography
                sx={{ position: 'absolute', bottom: 40, right: 10, zIndex: 10 }}
              >
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color="success"
                >
                  <Tooltip title={"New Designs"}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 150, // Adjust as necessary
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        New Designs
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              </Typography>
              )
              : ""
            }

            {/* {!quotationView && !proposalView ?<Typography sx={{ position: 'absolute', top: 8, right: 10, zIndex: 10 }}> */}
            {!proposalView ? (
              <Typography
                sx={{ position: 'absolute', top: 8, right: 10, zIndex: 10 }}
              >
                {!CommunityProjects ? (
                  community_name ? (
                    <Label
                      variant={
                        theme.palette.mode === 'light' ? 'ghost' : 'filled'
                      }
                      color={'warning'}
                    >
                      <Tooltip title={community_name}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontSize: '14px',
                            cursor: 'pointer',
                            display: 'inline-block',
                            maxWidth: 80, // Adjust as necessary
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {community_name}
                          </span>
                        </Typography>
                      </Tooltip>
                    </Label>
                  ) : (
                    <Label
                      variant={
                        theme.palette.mode === 'light' ? 'ghost' : 'filled'
                      }
                      color={'error'}
                    >
                      No project
                    </Label>
                  )
                ) : (
                  ''
                )}
              </Typography>
            ) : (
              ''
            )}
            {!CommunityProjects && !proposalView && (customer_name || is_split_order && for_parent_facility == 1) && (
              <Typography
                sx={{ position: 'absolute', bottom: 8, left: 10, zIndex: 10 }}
              >
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color="secondary"
                >
                  <Tooltip title={
                    is_split_order && for_parent_facility == 1 
                      ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                      : customer_name || ''
                  }>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 150, // Adjust as necessary
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {is_split_order && for_parent_facility == 1 
                          ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                          : customer_name || ''
                        }
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              </Typography>
            )}
            {
              <Typography
                sx={{ position: 'absolute', bottom: 8, right: 10, zIndex: 10 }}
              >
                {!CommunityProjects ? (
                  (participation_ends || (installation_start_date && installation_end_date)) ? (
                    <Label
                      variant={
                        theme.palette.mode === 'light' ? 'ghost' : 'filled'
                      }
                      color={'default'}
                    >
                      <Tooltip
                        title={
                          quotationView || proposalView
                            ? 'Date Created'
                            : 'Installation Date'
                        }
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontSize: '14px',
                            cursor: 'pointer',
                            display: 'inline-block',
                            maxWidth: 180, // Increased to accommodate date range
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {installation_start_date && installation_end_date ? (
                              `${moment.unix(installation_start_date).format('MM/DD/YYYY')} - ${moment.unix(installation_end_date).format('MM/DD/YYYY')}`
                            ) : (
                              moment.unix(participation_ends).format('MM/DD/YYYY')
                            )}
                          </span>
                        </Typography>
                      </Tooltip>
                    </Label>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
                {designOrder ? (
                  due_date ? (
                    <Label
                      variant={
                        theme.palette.mode === 'light' ? 'ghost' : 'filled'
                      }
                      color={'default'}
                    >
                      <Tooltip title={'Installation Date'}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontSize: '14px',
                            cursor: 'pointer',
                            display: 'inline-block',
                            maxWidth: 100,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {moment.unix(due_date).format('MM/DD/YYYY')}
                          </span>
                        </Typography>
                      </Tooltip>
                    </Label>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
              </Typography>
            }
          </Stack>
        </CardMediaStyle>
        <Box sx={{display:'flex',justifyContent: duplicated_from ? 'space-between' : 'center',alignItems:'center',padding:1}}>
            {
              duplicated_from && !edited_by ?
            <Stack
              sx={{
                mt: 2,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <Label
                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                color="error"
              >
                <Tooltip title={'Duplicated'}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: '14px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems:'center',
                      maxWidth: 150, // Adjust as necessary
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Icon icon={copyFill} width={16} height={16} style={{ marginRight: 6 }} />
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Duplicated
                    </span>
                  </Typography>
                </Tooltip>
              </Label>
            </Stack> : ''
            }
        {job_category_name ? (
          <Stack
            sx={{
              mt: 2,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Label
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color="info"
            >
              <Tooltip title={job_category_name}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '14px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    maxWidth: 150, // Adjust as necessary
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {job_category_name}
                  </span>
                </Typography>
              </Tooltip>
            </Label>
          </Stack>
        ) : (
          ''
        )}
        </Box>

        {designOrder && status == 1 && attachment_count > 0 && send_client_app_req == 1 ? (
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Label
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color="warning"
            >
              <Tooltip title={'Awaiting Approval'}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '14px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    maxWidth: 150, // Adjust as necessary
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Awaiting Approval
                  </span>
                </Typography>
              </Tooltip>
            </Label>
          </Stack>
        ) : (
          ''
        )}

        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Tooltip title={name}>
            {/* <Typography
              onClick={
                CommunityProjects
                  ? explodedPermissions?.some((permission) => [ 'Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost', ].includes(permission), ) || userType == 3
                    ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                    : () => enqueueSnackbar( 'Access Denied: You do not have sufficient permissions', { variant: 'error' },)
                  : quotationView
                        ? quotation_status != 6
                          ? () => quotation_status === 4 && quotation === 0
                                ? (explodedPermissions?.some((permission) =>['View Estimate, Edit Estimate, Delete Estimate'].includes(permission)) || (userType === 3 && status !== 6))
                                  ? () => handleOpenDetails(id, name)
                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                : (explodedPermissions?.some((permission) =>['Edit Estimate'].includes(permission)) || (userType === 3 && status !== 6))
                                  ? () => handleOpenViewEstimate(id, name)
                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                          : () => enqueueSnackbar( 'Access Denied: Rejected Quotation',{ variant: 'error' },)
                        : proposalView
                        ? proposal_count === 0
                          ? () => handleOpenViewPurchaseOrder(id, name)
                          : () => enqueueSnackbar( 'Access Denied: Proposals Submited', { variant: 'error' },)
                        : designOrder
                        ? (explodedPermissions?.some((permission) =>
                          ['View Design Order', 'Create Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                        ) || (userType === 3 && status !== 6))
                          ? () => handleOpenDetailsDesignOrder(id, name)
                          : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      : explodedPermissions?.some((permission) =>
                        [
                          'Create Request',
                          'Edit Request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                      (userType === 3 && status !== 6)
                    ? userType !== 3
                    ? empty(installationStatus)
                      ? () =>
                            // navigate(`/dashboard/official-request/view/${id}`)
                            handleOpenViewSalesOrder(id, name)
                      : () => enqueueSnackbar( 'Access Denied: Moved to installation Phase',{ variant: 'error' },)
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                      ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                    )
                      ? () => handleOpenDetails(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    // ? () =>
                    //     // navigate(`/dashboard/quick-bid/view/${id}`)
                    //     handleOpenDetails(id, name)
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                      ['View Design Order', 'Create Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                    )
                      ? () => handleOpenDetailsDesignOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : proposalView
                    ? statusRfp === null || statusRfp === 1
                      ? () => handleOpenViewPurchaseOrder(id, name)
                      : // navigate(`/dashboard/rfp/view/${id}`, { state: true })
                        () => enqueueSnackbar('Access Denied: Proposal submission closed',{ variant: 'error' },)
                    : () =>
                        // navigate(`/dashboard/official-request/view/${id}`)
                        handleOpenDetailsSalesOrder(id, name)
                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions',{ variant: 'error' },)
              }
              variant="subtitle1"
              sx={{
                mt: 2,
                ml: 2,
                maxWidth: userType != 3 && !CommunityProjects ? 150 : '70%',
                cursor: 'pointer',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: theme.palette.primary.main,
                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        [
                          'Add Jobs',
                          'Edit Jobs',
                          'Activate/Deactivate Jobs',
                          'Delete Jobs',
                          'Manage Job Cost',
                        ].includes(permission),
                      )
                      ? 'pointer'
                      : 'default'
                    : quotationView
                      ? explodedPermissions?.some((permission) =>
                        [ 'View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate', ].includes(permission)
                      )
                      ? 'pointer'
                      : 'default'
                    : designOrder
                      ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Create Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      )
                      ? 'pointer'
                      : 'default'
                    : (explodedPermissions?.some((permission) =>
                        [
                          'Create Request',
                          'Edit Request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                        (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {name}
              </span>
            </Typography> */}
            <Typography
              onClick={
                CommunityProjects
                  ? explodedPermissions?.some((permission) =>
                      ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                    ) || userType == 3
                    ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                    : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                  : quotationView
                  ? quotation_status != 6
                    ? ((quotation_status === 4 && quotation === 0) || userType === 3)
                      ? explodedPermissions?.some((permission) =>
                          ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                        ) || (userType === 3 && status !== 6)
                        ? () => handleOpenDetails(id, name)
                        : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      : explodedPermissions?.some((permission) =>
                          ['Edit Estimate'].includes(permission)
                        ) || (userType === 3 && status !== 6)
                        ? () => handleOpenViewEstimate(id, name)
                        : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : () => enqueueSnackbar('Access Denied: Rejected Quotation', { variant: 'error' })
                  : proposalView
                  ? proposal_count === 0
                    ? () => handleOpenViewPurchaseOrder(id, name)
                    : () => enqueueSnackbar('Access Denied: Proposals Submitted', { variant: 'error' })
                  : designOrder
                  ? explodedPermissions?.some((permission) =>
                      ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                    // ) || (userType === 3 && status !== 6)
                    ) || (userType === 3 )
                    // ? () => navigate(`/dashboard/design-order/view/${id}`)
                    ? () => handleOpenDetailsDesignOrder(id, name)
                    : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                  : explodedPermissions?.some((permission) =>
                      ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                    ) || (userType === 3 && status !== 6)
                  ? userType !== 3
                    ? empty(installationStatus)
                    // ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) :communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) : handleOpenViewSalesOrder(id, name)  
                    ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) :communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) : handleOpenViewSalesOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: Moved to installation Phase', { variant: 'error' })
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      )
                      ? () => handleOpenDetails(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      )
                      // ? () => navigate(`/dashboard/design-order/view/${id}`)
                      ? () => handleOpenDetailsDesignOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : proposalView
                    ? statusRfp === null || statusRfp === 1
                      ? () => handleOpenViewPurchaseOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: Proposal submission closed', { variant: 'error' })
                      // : () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) : communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) : handleOpenDetailsSalesOrder(id, name)
                      : () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) : communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) : handleOpenDetailsSalesOrder(id, name)
                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
              }
              variant="subtitle1"
              sx={{
                mt: 2,
                ml: 2,
                maxWidth: userType != 3 && !CommunityProjects ? 150 : '70%',
                cursor: 'pointer',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: theme.palette.primary.main,
                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : explodedPermissions?.some((permission) =>
                        ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {name}
              </span>
            </Typography>
          </Tooltip>
          {((userType != 3 && !CommunityProjects) || proposalView) && (
            <Typography
              onClick={
                CommunityProjects
                  ? explodedPermissions?.some((permission) =>
                      [
                        'Add Jobs',
                        'Edit Jobs',
                        'Activate/Deactivate Jobs',
                        'Delete Jobs',
                        'Manage Job Cost',
                      ].includes(permission),
                    ) || userType == 3
                    ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                    : () =>
                        enqueueSnackbar(
                          'Access Denied: You do not have sufficient permissions',
                          { variant: 'error' },
                        )
                  : quotationView
                    ? (explodedPermissions?.some((permission) =>
                      ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                    ) ||
                    (userType === 3 && status !== 6)) &&
                    !(userType === 3 && accept_status === 2)
                      ? () => handleOpenDetails(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      // ? () => handleOpenDetails(id, name)
                      // ? () => navigate(`/dashboard/quick-bid/view/${id}`)
                  : designOrder
                    ? (explodedPermissions?.some((permission) =>
                      ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                    ) ||
                    (userType === 3 && status !== 6)) &&
                    !(userType === 3 && accept_status === 2)
                    // ? () => navigate(`/dashboard/design-order/view/${id}`)  
                    ? () => handleOpenDetailsDesignOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                  :(explodedPermissions?.some((permission) =>
                      [
                        'Edit Request',
                        'View request',
                        'Delete request',
                        'Add vendor to request',
                        'Add client to request',
                      ].includes(permission),
                    ) ||
                      (userType === 3 && status !== 6)) &&
                    !(userType === 3 && accept_status === 2)
                  ? proposalView
                    ? () => handleOpenDetailsPurchaseOrder(id, name, false)
                    : // navigate(`/dashboard/rfp/view/${id}`)
                      () =>
                        CommunityJob ? 
                        navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) :
                        // communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) :
                        communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) :
                        handleOpenDetailsSalesOrder(id, name)
                  : () =>
                      enqueueSnackbar(
                        'Access Denied: You do not have sufficient permissions',
                        { variant: 'error' },
                      )
              }
              variant="subtitle1"
              sx={{
                mt: 3,
                mr: 2,
                color: theme.palette.primary.main,

                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        [
                          'Add Jobs',
                          'Edit Jobs',
                          'Activate/Deactivate Jobs',
                          'Delete Jobs',
                          'Manage Job Cost',
                        ].includes(permission),
                      )
                      ? 'pointer'
                      : 'default'
                    :  quotationView
                    ? (explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) ||
                      (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                      ? 'pointer'
                      : 'default'
                    :  designOrder
                    ? (explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      ) ||
                      (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                      ? 'pointer'
                      : 'default'
                    :
                    (explodedPermissions?.some((permission) =>
                        [
                          'Edit Request',
                          'View request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                        (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              {quotationView || proposalView ? 'Details' : 'Details'}
              {/* {quotationView || proposalView ? 'Details' : 'Sales Order Details'} */}
            </Typography>
          )}
        </Stack>
        <Typography
          variant="overline"
          align="center"
          sx={{ color: 'text.secondary' }}
        ></Typography>

        {/* <Divider /> */}

        {/* <Box sx={{display:"flex",justifyContent:"center"}}>

       <img src={QuickbookLogo} width={"50px"} height={"30px"}/>
    </Box> */}

        <Typography
          variant="subtitle1"
          align="center"
          sx={{ mt: 2 }}
        >
          Last updated {getAgoString(timestamp)}
        </Typography>

{avalara_code? (
        <Box sx={{ display: 'flex',ml:2 }}>
              <img
                src={AVALARALOGO}
                width={'20px'}
                height={'15px'}
                style={{ marginTop: '10px' }}
              />
              <Tooltip title={avalara_code}>
              <Typography sx={{ marginTop: '8px',color:"#fd6400",ml:0.6}}>
                {avalara_code ? ` #${avalara_code}` : ''}
              </Typography>
              </Tooltip>
            </Box>
            ):""}
          {
            designOrder ?  (
            <Box sx={{ display: 'flex', alignItems: 'center',alignContent:'center', mt: 2, gap: 1 ,px:2}}>
              <Box sx={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: 'primary.main', p: 1, border: '4px solid #80e2ff', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', textAlign: 'center' }}>
                <Typography sx={{
                  fontWeight: 600,
                  fontSize: '14px',
                  color: '#fff'
                }} >
                  ID
                </Typography>
              </Box>
              <Typography >
                {id ? `#${id}` : ''}
              </Typography>
            </Box>
            ) : (
              ''
          )}

        <Grid
          container
          sx={{
            textAlign: 'center',
            // justifyContent: 'space-between',
            justifyContent: syncWithQuickbooks ? 'space-between' : 'end',
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            pb: 2,
            pr: 2,
          }}
        >
          {syncWithQuickbooks ? (
            <Box sx={{ display: 'flex' , alignItems: 'center'}}>
              <img
                src={QuickbookLogo}
                width={'50px'}
                height={'25px'}
                style={{ marginTop: '10px' }}
              />
             
             <Box sx={{ display: "flex", flexDirection: "column", }}>
             
                  {
                (installation_acceptance && est_doc_number) && (doc_number !==est_doc_number)?
                <>
                  <Typography sx={{ marginTop: '13px',color:"#90EE90"}}>
                {est_doc_number ? `Job No: #${est_doc_number}` : ''}
              </Typography>
                    <Typography sx={{ marginTop: '1px',color:"#90EE90"}}>
                {doc_number ? `Inv No: #${doc_number}` : ''}
              </Typography>
              </>
                :
                est_doc_number == null ?
                <Typography sx={{ marginTop: '13px',color:"#90EE90"}}>
                {doc_number ? `Inv No: #${doc_number}` : ''}
              </Typography>
                :
                 <Typography sx={{ marginTop: '13px',color:"#90EE90"}}>
                {doc_number ? `Job No: #${doc_number}` : ''}
              </Typography>
              }
              </Box>
            </Box>
          ) : (
            ''
          )}

 <Box sx={{ alignSelf: 'flex-end' }}>
          {(userType === 3 &&
            proposalView &&
            statusRfp === 2 &&
            invoice_grand_total !== null &&
            invoice_grand_total !== undefined) ||
          (userType !== 3 &&
            proposalView &&
            awarded &&
            invoice_grand_total !== null &&
            invoice_grand_total !== undefined) ? (
            <Typography
              variant="body2"
              align="center"
              sx={{ color: theme.palette.success.main }}
            >
              <RequestQuote
                sx={{
                  width: 20,
                  height: 20,
                  color: theme.palette.success.main,
                  mt: 1,
                }}
              />
              {invoice_grand_total.toFixed(2)}
            </Typography>
          ) : (userType === 3 && proposalView && statusRfp !== 2) ||
            (userType !== 3 &&
              proposalView &&
              !awarded) ? null : invoice_grand_total !== null &&
            invoice_grand_total !== undefined ? (
            <Typography
              variant="body2"
              align="center"
              // sx={{ color: 'text.secondary' }}
            >
              <RequestQuote
                sx={{
                  width: 20,
                  height: 20,
                  color:
                    status === 4
                      ? theme.palette.success.main
                      : theme.palette.error.main,
                  mt: 1,
                }}
              />
              {invoice_grand_total.toFixed(2)}
            </Typography>
          ) : invoice_total ? (
            <Typography
              variant="body2"
              align="center"
              // sx={{ color: 'text.secondary' }}
            >
              <RequestQuote
                sx={{
                  width: 20,
                  height: 20,
                  color:
                    status === 4
                      ? theme.palette.success.main
                      : theme.palette.error.main,
                  mt: 1,
                }}
              />
              {invoice_total.toFixed(2)}
            </Typography>
          ) : null}
          </Box>
        </Grid>
      </Card>


    </>
  )
}
